import React from "react";

import { Typography } from "@mui/material";

export const ThamesSeperateLongDescription = () => {
  return (
    <>
      <Typography variant="body1" paragraph>
        In parts of outer London where there are separate pipes for carrying
        rainwater, there are significant capacity and water quality problems.
        Data source: Thames Water.
      </Typography>
    </>
  );
};

export const thamesSeperateShortDescription = "Mainly Outer London.";
